import { gql } from "@apollo/client";

export const getRoles = gql`
    query User_roles {
        user_roles {
            user_role_id
            position
            privileges
        }
    }
`;

export const getRole = gql`
    query User_role($userRoleId: ID!) {
        user_role(user_role_id: $userRoleId) {
            user_role_id
            position
            privileges
        }
    }
`;

export const createUserRole = gql`
    mutation CreateUserRole($position: String, $privileges: String) {
        createUserRole(position: $position, privileges: $privileges)
    }
`;

export const updateUserRole = gql`
    mutation UpdateUserRole(
        $userRoleId: ID
        $position: String
        $privileges: String
    ) {
        updateUserRole(
            user_role_id: $userRoleId
            position: $position
            privileges: $privileges
        )
    }
`;

export const getKEKEmployee = gql`
query KEKEmployee($employeeId: ID) {
  employee(employee_id: $employeeId) {
    employee_id
    employee_first_name
    employee_last_name
    employee_phonenumber
    employee_email
    emp_abbrv
    user {
      position
      user_role {
        position
        user_role_id
      }
    }
  }
}
`;
